import React, { useContext } from "react";
import { Box, Container, Typography } from "@mui/material";
import StorePolicy from "../../common/component/StorePolicy";
import ConfigContext from "../../common/context/ConfigContext";
import { formatPhoneNumber } from "../../common/util";

export default function AccessibilityStatement(props) {
  const siteConfig = useContext(ConfigContext);

  return (
    <Box pt={6} pb={10}>
      <Container maxWidth="md">
        <Box>
          <Box mb={4}>
            <Typography variant="h1" gutterBottom>
              Accessibility
            </Typography>
          </Box>
          <Typography variant="body1" sx={{ mb: 2 }}>
            {siteConfig.biz} is committed to making our website's content accessible and user
            friendly to everyone.
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            If you are having difficulty viewing or navigating the content on this website, or
            notice any content, feature, or functionality that you believe is not fully accessible
            to people with disabilities, please call our Customer Service team at{" "}
            <a href={`tel:${siteConfig.contact.phone}`}>
              {formatPhoneNumber(siteConfig.contact.phone)}
            </a>{" "}
            or email our team at{" "}
            <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a> with
            “Disabled Access” in the subject line and provide a description of the specific feature
            you feel is not fully accessible or a suggestion for improvement.
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            We take your feedback seriously and will consider it as we evaluate ways to accommodate
            all of our customers and our overall accessibility policies. Additionally, while we do
            not control such vendors, we strongly encourage vendors of third-party digital content
            to provide content that is accessible and user friendly.{" "}
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}
